import { memo } from 'react';

import classNames from 'classnames';

import Checkbox from '../../../../components/Checkbox/Checkbox';
import CheckMark from '../../../../components/SVGIcons/CheckMark';
import type { SignUpMarketingConsent } from '../../../../stores/marketing-consent/MarketingConsentStore.types';

import classes from './SignUpConsentsRedesign.module.scss';

export const SignUpConsentsRedesign = memo(function SignUpConsentsRedesign({
  showRequiredError,
  signUpMarketingConsents,
  marketingConsents,
  onChangeMarketingConsent,
}: {
  showRequiredError?: boolean;
  signUpMarketingConsents: SignUpMarketingConsent[];
  marketingConsents: Record<string, boolean>;
  onChangeMarketingConsent: (checked: boolean, id: string) => void;
}) {
  return (
    <div className={classes.signUpSections}>
      {signUpMarketingConsents.map((consent, index) => {
        const isChecked = marketingConsents[consent.id] ?? false;
        const isError = showRequiredError && consent.isApprovalRequired && !isChecked;

        return (
          <div key={consent.id} className={classNames(classes.checkboxWrapper, classes.consentRow)}>
            <Checkbox
              checked={isChecked}
              className={classNames(classes.checkbox, {
                [classes.checkboxError]: isError,
              })}
              dataTestId={`sign-up-marketing-consent-${index}`}
              icon={<CheckMark />}
              id={consent.id}
              onChange={(checked) => onChangeMarketingConsent(checked, consent.id)}
            />
            <label className={classes.termsLabel} htmlFor={consent.id}>
              {consent.text}
            </label>
          </div>
        );
      })}
    </div>
  );
});
